import Stack from 'src/app/atoms/Layout/Stack/Stack';
import { cssVar } from 'src/app/styles/helper';
import styled from 'styled-components';

export const HeaderPositioning = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  background-color: ${cssVar('bg-primary')};
`;

export const HeaderContainer = styled(Stack)`
  // Double background color is needed for SideNav masking
  background-color: ${cssVar('bg-primary')};
  height: ${cssVar('spacing-8xl')};

  & > .header-content {
    width: 100%;
  }
`;

export const HeaderLinks = styled(Stack)`
  flex: 1 1 auto;

  & > .header-menu-link {
    flex: 0 1 max-content;
    font-size: ${cssVar('font-size-text-md')};
    color: ${cssVar('text-secondary')};
    padding: ${cssVar('spacing-sm')};

    &.expanded {
      background-color: ${cssVar('bg-tertiary')};
    }

    &:focus {
      box-shadow: none;
    }
  }
`;

export const HeaderCtaContainer = styled(Stack)`
  & > a {
    width: max-content;
  }
`;
